<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11 21a1 1 0 102 0h-2zm1-18l.707-.707a1 1 0 00-1.414 0L12 3zM6.293 7.293a1 1 0 001.414 1.414L6.293 7.293zm10 1.414a1 1 0 101.414-1.414l-1.414 1.414zM13 21V3h-2v18h2zM11.293 2.293l-5 5 1.414 1.414 5-5-1.414-1.414zm0 1.414l5 5 1.414-1.414-5-5-1.414 1.414z"/></svg>